import { c as _c } from "react/compiler-runtime";
import { FilterChipSearch } from "@components/common/faro-table/faro-table-filter/filter-chip-search";
import { UserListItem } from "@components/common/members-autocomplete/user-list-item";
import { useMarkupContext } from "@context-providers/markup/markup-context";
import { Menu, Text } from "@flat-ui";
import { IElementType } from "@faro-lotv/ielement-types";
import { useProjectMarkupUpdate } from "@hooks/project-markups/use-project-markup-update";
import { Box } from "@mui-wrapper";
import { sortAssigneeMembers } from "@pages/project-details/project-markups/markup-assignee-utils";
import { setIElements } from "@store/i-elements/i-elements-slice-thunk";
import { markupsTemplateIdsSelector } from "@store/markups/markups-selector";
import { useAppDispatch, useAppSelector } from "@store/store-helper";
import { currentUserSelector } from "@store/user/user-selector";
import { getUserInitials } from "@utils/user-utils";
import { Fragment, useState } from "react";
/**
 * Returns the members whose name or email contains the search text, ignoring case,
 * sorted by name and then email with the current user first.
 */
function filterMembers(members, searchText, currentUserId) {
  const search = searchText.trim().toLowerCase();
  const matchingMembers = members.filter(member => [member.name, member.email].some(value => value?.toLowerCase().includes(search)));
  return sortAssigneeMembers(matchingMembers, currentUserId);
}

/**
 * Component responsible for rendering the editable content of the assignee name
 * in the markup.
 *
 * This component displays a TextField with a filterable list of project members,
 * allowing selection of a member as an assignee for a specific markup.
 */
export function MarkupAssigneeEditable(t0) {
  const $ = _c(67);
  const {
    closeAssigneeDropdown,
    anchorEl,
    setIsSpinnerLoading,
    projectMembers,
    markup,
    assigneeMember
  } = t0;
  const {
    projectId,
    setIsMarkupUpdating
  } = useMarkupContext();
  let t1;
  if ($[0] !== projectId) {
    t1 = {
      projectId
    };
    $[0] = projectId;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    updateNewMember
  } = useProjectMarkupUpdate(t1);
  const dispatch = useAppDispatch();
  const templateIds = useAppSelector(markupsTemplateIdsSelector);
  const currentUser = useAppSelector(currentUserSelector);
  const [searchText, setSearchText] = useState("");
  let T0;
  let T1;
  let t10;
  let t11;
  let t12;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[2] !== anchorEl || $[3] !== assigneeMember || $[4] !== closeAssigneeDropdown || $[5] !== currentUser || $[6] !== dispatch || $[7] !== markup || $[8] !== projectMembers || $[9] !== searchText || $[10] !== setIsMarkupUpdating || $[11] !== setIsSpinnerLoading || $[12] !== templateIds || $[13] !== updateNewMember) {
    const filteredMembers = filterMembers(projectMembers, searchText, currentUser?.identity);
    let t13;
    if ($[27] !== currentUser?.identity) {
      t13 = function mapOptionToUserItem(member) {
        return {
          title: member.name || member.email,
          userInitials: getUserInitials(member),
          userAvatarImg: member.thumbnailUrl,
          isCurrentUser: member.identity === currentUser?.identity
        };
      };
      $[27] = currentUser?.identity;
      $[28] = t13;
    } else {
      t13 = $[28];
    }
    const mapOptionToUserItem = t13;
    let t14;
    if ($[29] !== dispatch || $[30] !== setIsMarkupUpdating || $[31] !== setIsSpinnerLoading) {
      t14 = function processMarkupChanges(assignee) {
        dispatch(setIElements([assignee]));
        setIsSpinnerLoading(false);
        setIsMarkupUpdating(false);
      };
      $[29] = dispatch;
      $[30] = setIsMarkupUpdating;
      $[31] = setIsSpinnerLoading;
      $[32] = t14;
    } else {
      t14 = $[32];
    }
    const processMarkupChanges = t14;
    let t15;
    if ($[33] !== closeAssigneeDropdown || $[34] !== currentUser || $[35] !== markup || $[36] !== processMarkupChanges || $[37] !== setIsMarkupUpdating || $[38] !== setIsSpinnerLoading || $[39] !== templateIds || $[40] !== updateNewMember) {
      t15 = async function updateMember(newMember) {
        if (!templateIds) {
          throw new Error("Expected project to have an advanced markup template");
        }
        closeAssigneeDropdown();
        setIsSpinnerLoading(true);
        setIsMarkupUpdating(true);
        const mutation = await updateNewMember(markup, newMember, templateIds.assigneeTemplateId);
        if (!mutation || !currentUser) {
          return;
        }
        const currentAssignee = markup.assignee;
        if ("newElement" in mutation) {
          const newElement = mutation.newElement;
          const newItem = {
            ...newElement,
            type: IElementType.userDirectoryMarkupField,
            root_Id: newElement.rootId,
            createdBy: currentUser.identity,
            createdAt: mutation.createdAt,
            modifiedBy: currentUser.identity,
            modifiedAt: mutation.createdAt
          };
          processMarkupChanges(newItem);
          return;
        }
        if (!currentAssignee) {
          throw new Error("Assignee is required but was undefined.");
        }
        const newAssignee = {
          ...currentAssignee,
          id: mutation.elementId,
          createdAt: mutation.createdAt,
          values: [...mutation.ids]
        };
        processMarkupChanges(newAssignee);
      };
      $[33] = closeAssigneeDropdown;
      $[34] = currentUser;
      $[35] = markup;
      $[36] = processMarkupChanges;
      $[37] = setIsMarkupUpdating;
      $[38] = setIsSpinnerLoading;
      $[39] = templateIds;
      $[40] = updateNewMember;
      $[41] = t15;
    } else {
      t15 = $[41];
    }
    const updateMember = t15;
    T1 = Menu;
    t4 = Boolean(anchorEl);
    t5 = anchorEl;
    t6 = closeAssigneeDropdown;
    if ($[42] === Symbol.for("react.memo_cache_sentinel")) {
      t7 = {
        vertical: "bottom",
        horizontal: "left"
      };
      t8 = {
        vertical: "top",
        horizontal: "left"
      };
      $[42] = t7;
      $[43] = t8;
    } else {
      t7 = $[42];
      t8 = $[43];
    }
    t9 = "280px";
    if ($[44] === Symbol.for("react.memo_cache_sentinel")) {
      t10 = {
        paper: {
          sx: {
            width: "280px"
          }
        }
      };
      $[44] = t10;
    } else {
      t10 = $[44];
    }
    if ($[45] !== closeAssigneeDropdown || $[46] !== searchText) {
      t11 = <FilterChipSearch searchText={searchText} setSearchText={setSearchText} onEscape={closeAssigneeDropdown} />;
      $[45] = closeAssigneeDropdown;
      $[46] = searchText;
      $[47] = t11;
    } else {
      t11 = $[47];
    }
    let t16;
    if ($[48] === Symbol.for("react.memo_cache_sentinel")) {
      t16 = {
        height: "36px",
        display: "flex",
        alignItems: "center",
        padding: "8px"
      };
      $[48] = t16;
    } else {
      t16 = $[48];
    }
    if ($[49] === Symbol.for("react.memo_cache_sentinel")) {
      t12 = <Box sx={t16}><Text variant="labelS" sx={{
          lineHeight: "14px",
          color: "text.primary"
        }}>ASSIGNEE MEMBER</Text></Box>;
      $[49] = t12;
    } else {
      t12 = $[49];
    }
    T0 = Box;
    if ($[50] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = {
        maxHeight: "236px",
        overflowY: "auto",
        padding: "8px"
      };
      $[50] = t2;
    } else {
      t2 = $[50];
    }
    t3 = filteredMembers.length === 0 ? <Box sx={{
      height: "36px",
      display: "flex",
      alignItems: "center",
      px: 2,
      pointerEvents: "none"
    }}><Text variant="bodyS" sx={{
        color: "text.primary"
      }}>No member found!</Text></Box> : filteredMembers.map((member_0, index) => <Fragment key={index}><Box onClick={() => {
        if (member_0.identity !== assigneeMember?.identity) {
          updateMember(member_0);
        }
      }}><UserListItem item={mapOptionToUserItem(member_0)} inputValue={searchText} isActive={assigneeMember ? member_0.identity === assigneeMember?.identity : false} /></Box></Fragment>);
    $[2] = anchorEl;
    $[3] = assigneeMember;
    $[4] = closeAssigneeDropdown;
    $[5] = currentUser;
    $[6] = dispatch;
    $[7] = markup;
    $[8] = projectMembers;
    $[9] = searchText;
    $[10] = setIsMarkupUpdating;
    $[11] = setIsSpinnerLoading;
    $[12] = templateIds;
    $[13] = updateNewMember;
    $[14] = T0;
    $[15] = T1;
    $[16] = t10;
    $[17] = t11;
    $[18] = t12;
    $[19] = t2;
    $[20] = t3;
    $[21] = t4;
    $[22] = t5;
    $[23] = t6;
    $[24] = t7;
    $[25] = t8;
    $[26] = t9;
  } else {
    T0 = $[14];
    T1 = $[15];
    t10 = $[16];
    t11 = $[17];
    t12 = $[18];
    t2 = $[19];
    t3 = $[20];
    t4 = $[21];
    t5 = $[22];
    t6 = $[23];
    t7 = $[24];
    t8 = $[25];
    t9 = $[26];
  }
  let t13;
  if ($[51] !== T0 || $[52] !== t2 || $[53] !== t3) {
    t13 = <T0 sx={t2}>{t3}</T0>;
    $[51] = T0;
    $[52] = t2;
    $[53] = t3;
    $[54] = t13;
  } else {
    t13 = $[54];
  }
  let t14;
  if ($[55] !== T1 || $[56] !== t10 || $[57] !== t11 || $[58] !== t12 || $[59] !== t13 || $[60] !== t4 || $[61] !== t5 || $[62] !== t6 || $[63] !== t7 || $[64] !== t8 || $[65] !== t9) {
    t14 = <T1 open={t4} anchorEl={t5} onClose={t6} anchorOrigin={t7} transformOrigin={t8} minWidth={t9} slotProps={t10}>{t11}{t12}{t13}</T1>;
    $[55] = T1;
    $[56] = t10;
    $[57] = t11;
    $[58] = t12;
    $[59] = t13;
    $[60] = t4;
    $[61] = t5;
    $[62] = t6;
    $[63] = t7;
    $[64] = t8;
    $[65] = t9;
    $[66] = t14;
  } else {
    t14 = $[66];
  }
  return t14;
}